export enum ControlPanelOptions {
    viewBwic = 'viewBwic',
    viewInventory = 'viewInventory',
    addToPortfolio = 'addToPortfolio'
}
